/* Caja de compra: eleccion de pack, precio en el boton y acordeon.
   El alto de la lista "lo que incluye" y el del acordeon se animan con
   grid-template-rows de 0fr a 1fr, asi no hay que medir nada con JS. */
(function(){
  var caja=document.querySelector('.rz-pk');
  if(!caja) return;


  /* ──────────────────────────────────────────────────────────────
     EL PUENTE CON KACHING
     Kaching sabe dos cosas que nosotros no: cual es el precio de cada escalon
     y que regalos lleva. El precio nos llega solo, porque lo aplica una
     funcion del servidor que solo mira cuantas unidades hay en el carrito.
     El REGALO no: lo agrega el widget de ellos, del lado del navegador, y solo
     si su barra correspondiente esta elegida.

     Entonces el bloque de Kaching vive en la ficha pero no se ve —lo tapa
     .rz-kaching-oculto— y estas dos funciones lo manejan por atras: cuando el
     cliente toca una de NUESTRAS tarjetas, se marca la barra de ellos que
     tiene la misma cantidad. Cuando despues se aprieta el CTA, el carrito
     manda el pedido con fetch, Kaching lo intercepta y le engancha los
     regalos en $0.
     MEDIDO el 20/09: pack de 6 -> 6 shampoos $99.990 + 3 acondicionadores $0.

     ⚠️ SE TOCA EL <input type=radio> DE ELLOS, no el contenedor. El click
     sobre la barra entera no les cambia el estado: probado, quedaba elegido el
     escalon de 3 que viene por defecto y el carrito salia con el regalo
     equivocado.

     ⚠️ SI ESTO SE ROMPE, NO SE ROMPE LA VENTA. Si el bloque de Kaching no
     esta, o cambian sus clases, sincronizarKaching no encuentra nada y no
     hace nada: el cliente compra igual y al precio correcto, solo que sin el
     regalo automatico. Nunca al reves. */
  function bloqueKaching(){ return document.querySelector('kaching-bundles-block'); }

  function ocultarKaching(){
    var b=bloqueKaching(); if(!b) return false;
    var cont=b.closest ? b.closest('.shopify-app-block, .product__block') : null;
    (cont||b).classList.add('rz-kaching-oculto');
    return true;
  }

  function sincronizarKaching(unidades){
    if(!unidades) return;
    var b=bloqueKaching(); if(!b) return;
    var barras=b.querySelectorAll('.kaching-bundles__bar');
    for(var i=0;i<barras.length;i++){
      /* La barra se reconoce por su numero, que es el mismo que el nuestro.
         Se lee del texto y no de un atributo porque el atributo no lo exponen. */
      var m=(barras[i].textContent||'').match(/(\d+)\s*SHAMPOO/i);
      if(m && m[1]===String(unidades)){
        var radio=barras[i].querySelector('input[type=radio]');
        if(radio && !radio.checked) radio.click();
        return;
      }
    }
  }

  /* El bloque de ellos puede tardar en aparecer. Se espera un rato corto y se
     deja de insistir: no vale la pena un observer eterno por esto. */
  (function esperar(intentos){
    if(ocultarKaching()){
      var on=caja.querySelector('.rz-pk__card.is-on input[type=radio]');
      if(on) sincronizarKaching(on.getAttribute('data-unidades'));
      return;
    }
    if(intentos>0) setTimeout(function(){ esperar(intentos-1); }, 400);
  })(25);

  /* ---- packs ---- */
  var cards=caja.querySelectorAll('.rz-pk__card');
  var campo=document.getElementById('rz-pk-id');
  var cta=document.getElementById('rz-pk-cta');

  function pintar(){
    var elegida=null;
    for(var i=0;i<cards.length;i++){
      var r=cards[i].querySelector('input[type=radio]');
      var on=r && r.checked;
      cards[i].classList.toggle('is-on',!!on);
      if(on) elegida=cards[i];
    }
    if(!elegida) return;
    var r2=elegida.querySelector('input[type=radio]');
    /* ⚠️ Al carrito va el SKU de 1 con la cantidad del pack, NO la variante de
       pack con cantidad 1. El porque esta en el comentario largo de
       pdp_compra.liquid: sobre las variantes de pack, Kaching aplicaba el
       descuento dos veces y 12 botellas salian mas baratas que 3.
       Si data-base no esta, se cae a la variante de pack, que es el
       comportamiento anterior: peor precio para nosotros, nunca un carrito
       roto para el cliente. */
    var formPk=document.getElementById('rz-pk-form');
    var base=formPk && formPk.getAttribute('data-base');
    var qty=document.getElementById('rz-pk-qty');
    if(campo) campo.value = base || r2.value;
    if(qty)   qty.value   = base ? (r2.getAttribute('data-unidades') || '1') : '1';
    /* El mismo numero viaja como propiedad de linea: es lo que despues lee el
       carrito para no dejar bajar de ahi. */
    var minimo=document.getElementById('rz-pk-min');
    if(minimo) minimo.value = base ? (r2.getAttribute('data-unidades') || '1') : '1';
    sincronizarKaching(r2.getAttribute('data-unidades'));
    /* Se escribe SOLO el span del texto, no el boton entero: con textContent
       sobre el boton se borraban las dos capas (texto y spinner) y el estado de
       carga dejaba de existir apenas cambiabas de pack. */
    if(cta){
      var etiqueta=cta.querySelector('.rz-pk__cta-txt') || cta;
      etiqueta.textContent='Aprovechar el Cyber | ' /* CYBER: en el tema original dice 'Empezar el tratamiento' */+elegida.getAttribute('data-precio');
    }
  }

  for(var i=0;i<cards.length;i++){
    cards[i].addEventListener('change',pintar);
    /* La tarjeta entera es un <label>, asi que el click ya marca el radio.
       Este listener es para el teclado y para el caso en que el navegador no
       dispare change por venir de otra tarjeta. */
    cards[i].addEventListener('click',function(){ setTimeout(pintar,0); });
  }
  pintar();

  /* ---- acordeon ---- */
  var items=caja.querySelectorAll('.rz-pk__item');
  for(var j=0;j<items.length;j++){
    (function(it){
      var btn=it.querySelector('.rz-pk__btn');
      var cont=it.querySelector('.rz-pk__cont');
      if(!btn||!cont) return;
      btn.setAttribute('aria-expanded','false');
      btn.addEventListener('click',function(){
        var abierto=!it.classList.contains('is-on');
        /* Uno solo abierto a la vez: al abrir uno se cierra el que estaba.
           Pedido de Mark. */
        for(var k=0;k<items.length;k++){
          items[k].classList.remove('is-on');
          var b2=items[k].querySelector('.rz-pk__btn');
          if(b2) b2.setAttribute('aria-expanded','false');
        }
        if(abierto){
          it.classList.add('is-on');
          btn.setAttribute('aria-expanded','true');
        }
      });
    })(items[j]);
  }
})();


/* ---------- estado de carga del CTA ----------
   Al enviar el formulario, el boton pasa a spinner y queda inhabilitado hasta
   que se abre el carrito. El fin del estado se detecta mirando cuando
   .rz-cart toma la clase is-open, que es como el cajon se abre; si por lo que
   sea no abriera, a los 8 segundos se libera igual para no dejar el boton
   muerto. */
(function(){
  var form=document.getElementById('rz-pk-form') || document.querySelector('form[action*="/cart/add"]');
  if(!form) return;
  var botones=[document.getElementById('rz-pk-cta'), document.querySelector('.rz-atc__cta')];

  function marcar(on){
    for(var i=0;i<botones.length;i++){
      if(!botones[i]) continue;
      botones[i].classList.toggle('esta-cargando', on);
      if(on) botones[i].setAttribute('aria-busy','true');
      else botones[i].removeAttribute('aria-busy');
    }
  }

  var suelta=null;
  function liberar(){
    if(suelta){ clearTimeout(suelta); suelta=null; }
    marcar(false);
  }

  /* Se suelta cuando se abre el cajon del carrito (con el pack 6 el submit no llega: lo agrega Kaching). */
  function esperarCajon(){
    var cajon=document.querySelector('.rz-cart'); if(!cajon) return;
    var obs=new MutationObserver(function(){ if(cajon.classList.contains('is-open')){ obs.disconnect(); liberar(); } });
    obs.observe(cajon,{attributes:true,attributeFilter:['class']});
  }
  /* En el click (y no en el pointerdown: el CSS de esta-cargando le saca los clicks al boton). Se escucha en
     window en captura para correr antes que Kaching, que con el pack de 6 frena el evento y agrega solo. */
  window.addEventListener('click',function(e){
    var b=e.target && e.target.closest && e.target.closest('#rz-pk-cta, .rz-atc__cta');
    if(!b) return;
    setTimeout(function(){ marcar(true); esperarCajon(); if(!suelta) suelta=setTimeout(liberar,8000); },0);
  },true);
  form.addEventListener('submit',function(){
    marcar(true);
    var cajon=document.querySelector('.rz-cart');
    if(cajon){
      var obs=new MutationObserver(function(){
        if(cajon.classList.contains('is-open')){ obs.disconnect(); liberar(); }
      });
      obs.observe(cajon,{attributes:true,attributeFilter:['class']});
    }
    suelta=setTimeout(liberar,8000);
  });
})();
